"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const useProperty_1 = tslib_1.__importDefault(require("../utils/useProperty"));
exports.default = (props) => {
    return (0, useProperty_1.default)(props, 'isOpen', true, {
        onChange: (isOpen) => {
            if (!isOpen && props.onDismiss) {
                props.onDismiss();
            }
        },
    });
};
